module.exports = __webpack_public_path__ + "static/banner-update-data-ec-MB-a9aaf8cae16822f752dc2c454afd87b0.png";